// @ts-nocheck
/* eslint-disable */
import SceneCoords from "~/scene/common/coords";

(function() {
	const ns = "http://www.w3.org/2000/svg";

	class GeometryPathTraffic extends SMap.Geometry {
		constructor(type, id, coords, options) {
			let c = [];
			for (let i = 0; i < coords.length; i++) {
				c.concat(coords[i]);
			}

			super(type, id, c, {});
			this.appended = false;
			this._nodes = [];
			this._geometries = [];
			this._colors = [];
			this._opt = options;
			this._crds = coords;
			this._active = true;

			this._prepareData(coords, options);
		}

		$destructor() {
			this.clear();
			this._coords = [];
			this._geometries = [];
			this._colors = [];
			this.appended = false;
		}

		getOptions() {
			return this._opt;
		}

		setOptions(opt) {
			this._opt = opt;
			this._prepareData(this._crds, opt);
		}

		getNodes() {
			return this._nodes;
		}

		clear() {
			for (let i = 0; i < this._nodes.length; i++) {
				this._nodes[i].remove();
			}

			this._nodes = [];

			this._bbox = {
				min: null,
				max: null
			};
		}

		draw(canvas, offset) {
			requestAnimationFrame(() => {
				for (let color = 0; color < this._colors.length; color++) {
					let coords = this._geometries[color];
					let style = {};

					for (let i = 0; i < this._opt.length; i++) {
						if (this._colors[color] == this._opt[i].color) {
							style = this._opt[i];
							break;
						}
					}

					if (coords.length) {
						let d = "";

						for (let i = 0; i < coords.length; i++) {
							let data = this._convertCoords(coords[i], offset); // prepocitat zemepisne souradnice na pixelove
							d += `M ${data[0].x} ${data[0].y}`;

							for (let c = 1; c < data.length; c++) {
								d += ` L ${data[c].x} ${data[c].y}`;
							}

							//d += " Z ";
						}

						let el = document.createElementNS(ns, "path");
						el.setAttribute("fill", "none");
						el.setAttribute("stroke", style.color);
						el.setAttribute("stroke-width", style.width);
						el.setAttribute("stroke-linejoin", "round");
						el.setAttribute("stroke-linecap", "square");
						el.setAttribute("fill-opacity", style.opacity);
						el.setAttribute("stroke-opacity", style.opacity);
						el.setAttribute("d", d);

						this._nodes.push(el);
						canvas.getContent().appendChild(el);
					}
				}
			});
		}

		computeCenterZoom(map, usePadding) {
			let coords = [];

			for (let i = 0; i < this._coords.length; i++) {
				let item = this._coords[i];

				if (!(item instanceof Array)) { item = [item]; }

				for (let j = 0; j < item.length; j++) {
					let c = item[j];

					if (!(c instanceof SceneCoords)) { continue; }

					coords.push(c);
				}
			}

			return this._scene.computeCenterZoom(coords, usePadding);
		}

		/**
		 * Nastavi bbox geometrie.
		 */
		countBBox() {
			let minX = Infinity;
			let minY = Infinity;
			let maxX = -Infinity;
			let maxY = -Infinity;

			this._coords.forEach(coor => {
				minX = Math.min(coor.x, minX);
				minY = Math.min(coor.y, minY);
				maxX = Math.max(coor.x, maxX);
				maxY = Math.max(coor.y, maxY);
			});

			this._bbox.min = SMap.Coords.fromWGS84(minX, minY);
			this._bbox.max = SMap.Coords.fromWGS84(maxX, maxY);
		}

		/**
		 * Vrati bboxu geometrie
		 *
		 * @return {Object} BBox x, y, width, height
		 */
		getBBox() {
			let output = {
				x: 0,
				y: 0,
				width: 0,
				height: 0
			};

			if (this._bbox.min && this._bbox.max) {
				let map = this.getMap();
				let minBB = this._bbox.min.toPixel(map);
				let maxBB = this._bbox.max.toPixel(map);
				let size = map.getSize();

				output.x = Math.round(Math.min(minBB.x, maxBB.x) + size.x / 2);
				output.y = Math.round(Math.min(minBB.y, maxBB.y) + size.y / 2);
				output.width = Math.round(Math.abs(maxBB.x - minBB.x));
				output.height = Math.round(Math.abs(maxBB.y - minBB.y));
			}

			return output;
		}

		_convertCoords(coords, offset) {
			let map = this.getMap();
			this._pixels = [];

			let result = [];
			let last = null;

			for (let i = 0; i < coords.length; i++) {
				let item = coords[i];
				if (item instanceof SceneCoords) { /* souradnice */
					item = item.toPixel();

					last = item.clone();
					this._pixels.push(last);
					item.plus(offset);
				}
				else if (item instanceof Array) { /* pole souradnic */
					last = null;

					let arr = [];

					for (let j = 0; j < item.length; j++) {
						last = null;
						item = item.map(c => c.toPixel(map.getZoom()).plus(offset));
					}

					item = arr;
				}
				result.push(item);
			}
			return result;
		}

		_prepareData(coords, options) {
			for (let i = 0; i < options.length; i++) {
				let index = this._colors.indexOf(options[i].color)
				if (index == -1) {
					this._colors.push(options[i].color);
					this._geometries.push([]);
					this._geometries[this._geometries.length-1].push(coords[i]);
				}
				else {
					this._geometries[index].push(coords[i]);
				}
			}
		}
	}

	Mapy.Geometry = {
		Path: {}
	};
	Mapy.Geometry.Path.Traffic = GeometryPathTraffic;
})();
